<template>
    <div class="group-inputs">

        <!-- <div class="f-90 gray-600 mb-1"> *NICE평가정보에서 ESG 평가 신청 후 계정 안내를 못 받으신 경우, <b>info@qesg.co.kr</b>로 문의 바랍니다.</div> -->

        <!-- 여러 화면(로그인 전 화면·푸터·도움말 버튼)에서 쓰여 id 에 _uid 를 붙인다 -->
        <b-form-group :label="`${$t('성함')} *`" :label-for="`cs-name-${_uid}`" label-class="gray-600 pb-1" class="mb-2"
                      :state="name_state" :invalid-feedback="$t('필수 항목을 모두 입력해주세요.')">
            <b-form-input :id="`cs-name-${_uid}`" v-model="name" type="text" required :state="name_state"></b-form-input>
        </b-form-group>

        <b-form-group :label="`${$t('이메일')} *`" :label-for="`cs-email-${_uid}`" label-class="gray-600 pb-1" class="mb-2"
                      :state="e_mail_state" :invalid-feedback="$t('이메일을 정확히 입력하여 주십시오.')">
            <b-form-input :id="`cs-email-${_uid}`" v-model="e_mail" type="email" required :state="e_mail_state" placeholder="name@example.com"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('소속')" :label-for="`cs-company-${_uid}`" label-class="gray-600 pb-1" class="mb-3">
            <b-form-input :id="`cs-company-${_uid}`" v-model="company" type="text" :placeholder="modal_company"></b-form-input>
        </b-form-group>

        <b-form-group :label="`${$t('문의사항')} *`" :label-for="`cs-requirements-${_uid}`" label-class="gray-600 pb-1" class="mb-0"
                      :state="requirements_state" :invalid-feedback="$t('필수 항목을 모두 입력해주세요.')">
            <b-textarea :id="`cs-requirements-${_uid}`" v-model="requirements" rows="6" required :state="requirements_state"
                        :placeholder="$t(`문의사항을 작성해 주세요.`)"></b-textarea>
        </b-form-group>

        <div class="f-90 text-right mb-4">
            {{ $t(`평균 1시간 이내에 답변 드립니다. *은 필수입력 항목입니다.`) }}
        </div>

        <div v-if="mail_sending==false" class="d-flex justify-content-end mb-2">
            <b-button variant="dark" @click="hideModal">{{ $t(`취소`) }}</b-button>
            <b-button class="ml-2" variant="blue" @click="saveCustomerService">{{ $t(`문의하기`) }}
                <fa icon="paper-plane" class="ml-1"></fa>
            </b-button>
        </div>
        <div v-if="mail_sending==true" class="d-flex justify-content-end mb-2">
            <b-spinner size="small"></b-spinner>
            {{ $t(`문의사항을 전송하는 중입니다. 잠시 기다려 주세요.`) }}
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'customer-service',
    data() {
        return {
            selected: [],
            options: [
                {text: 'ESG 평가', value: 'ESG 평가'},
                {text: '지속가능경영 정보 공개', value: '웹 리포팅'},
                {text: '기타', value: '기타'}
            ],

            name: '',
            company: '',
            e_mail: '',
            requirements: '',
            // 문의하기를 한 번 누른 뒤부터 칸별 오류를 보여 준다
            is_submitted: false,

            modal_company: this.$t('회사'),

            mail_sending: false,
        };
    },
    computed: {
        ...mapState({
            user_id: state => state.user_id,
            store_e_mail: state => state.e_mail,
            user_name: state => state.user_name,
            company_name: state => state.company_name,
            campaign_in_progress: state => state.campaign_in_progress,
            template_in_progress: state => state.template_in_progress,
            question_in_progress: state => state.question_in_progress
        }),
        name_state () {
            return this.is_submitted ? !!(this.name || '').trim() : null;
        },
        e_mail_state () {
            return this.is_submitted ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.e_mail || '').trim()) : null;
        },
        requirements_state () {
            return this.is_submitted ? !!(this.requirements || '').trim() : null;
        }
    },
    created() {
        this.name = this.user_name;
        this.company = this.company_name;
        this.e_mail = this.store_e_mail;
        // 참여 중인 평가가 있을 때만 '<평가명> 관련 문의' 로 미리 채운다 (없으면 빈 칸 — 내용 없는 문의 방지)
        const campaign_name = this.campaign_in_progress && this.campaign_in_progress.campaign_name;
        this.requirements = campaign_name ? this.$t('{campaign_name} 관련 문의', { campaign_name }) : '';
    },
    mounted() {
    },
    methods: {
        async saveCustomerService() {
            this.is_submitted = true;
            const invalid_field = [['name', this.name_state], ['email', this.e_mail_state], ['requirements', this.requirements_state]]
                .find(([, state]) => !state);
            if (invalid_field) {
                const el = document.getElementById(`cs-${invalid_field[0]}-${this._uid}`);
                if (el) el.focus();
                return;
            }
            this.mail_sending = true;
            let formData = new FormData;
            formData.append('name', this.name.trim());
            formData.append('company', this.company);
            formData.append('e_mail', this.e_mail.trim());
            formData.append('requirements', this.requirements);
            formData.append('source', 'qesg_assessment');

            try {
                await this.$axios.post('/save_customer_service', formData);
            } catch (error) {
                console.log(error);
                this.mail_sending = false;
                this.$EventBus.$emit('toast-failure', this.$t('알림'), this.$t('문의사항 접수에 실패했습니다. 잠시 후 다시 시도해 주세요.'));
                return;
            }
            this.mail_sending = false;
            this.$EventBus.$emit('toast-success', this.$t('알림'), this.$t('문의사항을 접수하였습니다. 최대한 빠르게 답변드리도록 하겠습니다.'));
            this.hideModal();

            try {
                await this.$axios.post('/send_customer_service_mail', formData);
            } catch (error) {
                console.log(error);
                this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('문의사항은 접수되었으나 확인 메일 발송에 실패했습니다.'));
            }
        },
        hideModal() {
            // 사용처마다 모달 id/ref 가 다르다(layout-auth·Footer: customer-service, MainMaster: ref need-help)
            this.$emit('close-need-help');
            this.$bvModal.hide('customer-service');
        }

    }
};
</script>

<style scoped>

</style>
